import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';

type updateAICountersParams = {
    email:string
}

const queryUpdateAICounter = gql`
mutation ClearAiCounters($email: String!) {
  clearAiCounters(email: $email)
}
`;
export const updateAICounters = async (payload:{ email: string}) => {
  const response = await graphQLClient().request<any, updateAICountersParams>(queryUpdateAICounter, payload);
  return response;
};